import { render, staticRenderFns } from "./DishLimit.vue?vue&type=template&id=25716266&lang=pug"
import script from "./DishLimit.vue?vue&type=script&lang=js"
export * from "./DishLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports